"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iframeResizer;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
require("core-js/modules/es6.string.starts-with.js");
require("core-js/modules/es6.string.ends-with.js");
require("core-js/modules/es6.array.filter.js");
var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));
function cov_28pkpc9hz5() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/iframeResizer.js";
  var hash = "1266ae5268521fa21b74b715bd8e835f93efe043";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/iframeResizer.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 17
        },
        end: {
          line: 14,
          column: 4
        }
      },
      "1": {
        start: {
          line: 2,
          column: 14
        },
        end: {
          line: 2,
          column: 24
        }
      },
      "2": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 13,
          column: 4
        }
      },
      "3": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 34
        }
      },
      "4": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      "5": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 26
        }
      },
      "6": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 35
        }
      },
      "7": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 44
        }
      },
      "8": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 39
        }
      },
      "9": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 21
        }
      },
      "10": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 20,
          column: 10
        }
      },
      "11": {
        start: {
          line: 23,
          column: 14
        },
        end: {
          line: 23,
          column: 43
        }
      },
      "12": {
        start: {
          line: 24,
          column: 15
        },
        end: {
          line: 24,
          column: 23
        }
      },
      "13": {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "14": {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 27,
          column: 33
        }
      },
      "15": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 95
        }
      },
      "16": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 34,
          column: 58
        }
      },
      "17": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 58
        }
      },
      "18": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 48
        }
      },
      "19": {
        start: {
          line: 34,
          column: 21
        },
        end: {
          line: 34,
          column: 56
        }
      },
      "20": {
        start: {
          line: 39,
          column: 16
        },
        end: {
          line: 39,
          column: 45
        }
      },
      "21": {
        start: {
          line: 40,
          column: 17
        },
        end: {
          line: 40,
          column: 25
        }
      },
      "22": {
        start: {
          line: 42,
          column: 19
        },
        end: {
          line: 42,
          column: 65
        }
      },
      "23": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 34
        }
      },
      "24": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 36
        }
      },
      "25": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 67
        }
      },
      "26": {
        start: {
          line: 49,
          column: 27
        },
        end: {
          line: 49,
          column: 67
        }
      },
      "27": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 36
        }
      },
      "28": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 18
          },
          end: {
            line: 1,
            column: 19
          }
        },
        loc: {
          start: {
            line: 1,
            column: 24
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 9
          },
          end: {
            line: 4,
            column: 10
          }
        },
        loc: {
          start: {
            line: 4,
            column: 21
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 4
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 11,
            column: 15
          },
          end: {
            line: 11,
            column: 16
          }
        },
        loc: {
          start: {
            line: 11,
            column: 21
          },
          end: {
            line: 11,
            column: 39
          }
        },
        line: 11
      },
      "3": {
        name: "makeLinksOpenOnTop",
        decl: {
          start: {
            line: 22,
            column: 9
          },
          end: {
            line: 22,
            column: 27
          }
        },
        loc: {
          start: {
            line: 22,
            column: 36
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 26,
            column: 22
          },
          end: {
            line: 26,
            column: 23
          }
        },
        loc: {
          start: {
            line: 26,
            column: 30
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 26
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 32,
            column: 12
          },
          end: {
            line: 32,
            column: 13
          }
        },
        loc: {
          start: {
            line: 32,
            column: 20
          },
          end: {
            line: 32,
            column: 58
          }
        },
        line: 32
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 33,
            column: 12
          },
          end: {
            line: 33,
            column: 13
          }
        },
        loc: {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 48
          }
        },
        line: 33
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 34,
            column: 13
          },
          end: {
            line: 34,
            column: 14
          }
        },
        loc: {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 34,
            column: 56
          }
        },
        line: 34
      },
      "8": {
        name: "iframeResizer",
        decl: {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 37,
            column: 37
          }
        },
        loc: {
          start: {
            line: 37,
            column: 54
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 37
      },
      "9": {
        name: "resizeIframe",
        decl: {
          start: {
            line: 38,
            column: 11
          },
          end: {
            line: 38,
            column: 23
          }
        },
        loc: {
          start: {
            line: 38,
            column: 42
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 38
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 49,
            column: 21
          },
          end: {
            line: 49,
            column: 22
          }
        },
        loc: {
          start: {
            line: 49,
            column: 27
          },
          end: {
            line: 49,
            column: 67
          }
        },
        line: 49
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 20,
            column: 10
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 30
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 36
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 33
          }
        }, {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 10
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 27
          }
        }, {
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 29,
            column: 66
          }
        }, {
          start: {
            line: 29,
            column: 70
          },
          end: {
            line: 29,
            column: 94
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1266ae5268521fa21b74b715bd8e835f93efe043"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28pkpc9hz5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28pkpc9hz5();
var polyfill = (cov_28pkpc9hz5().s[0]++, function () {
  cov_28pkpc9hz5().f[0]++;
  var clock = (cov_28pkpc9hz5().s[1]++, (0, _now.default)());
  cov_28pkpc9hz5().s[2]++;
  return function (callback) {
    cov_28pkpc9hz5().f[1]++;
    var currentTime = (cov_28pkpc9hz5().s[3]++, (0, _now.default)());
    cov_28pkpc9hz5().s[4]++;
    if (currentTime - clock > 16) {
      cov_28pkpc9hz5().b[0][0]++;
      cov_28pkpc9hz5().s[5]++;
      clock = currentTime;
      cov_28pkpc9hz5().s[6]++;
      return callback(currentTime);
    } else {
      cov_28pkpc9hz5().b[0][1]++;
    }
    cov_28pkpc9hz5().s[7]++;
    setTimeout(function () {
      cov_28pkpc9hz5().f[2]++;
      cov_28pkpc9hz5().s[8]++;
      return polyfill(callback);
    }, 0);
    cov_28pkpc9hz5().s[9]++;
    return undefined;
  };
}());
var requestAnimationFrame = (cov_28pkpc9hz5().s[10]++, (cov_28pkpc9hz5().b[1][0]++, window.requestAnimationFrame) || (cov_28pkpc9hz5().b[1][1]++, window.webkitRequestAnimationFrame) || (cov_28pkpc9hz5().b[1][2]++, window.mozRequestAnimationFrame) || (cov_28pkpc9hz5().b[1][3]++, polyfill));
function makeLinksOpenOnTop(iframe) {
  cov_28pkpc9hz5().f[3]++;
  var doc = (cov_28pkpc9hz5().s[11]++, iframe.contentWindow.document);
  var body = (cov_28pkpc9hz5().s[12]++, doc.body);
  cov_28pkpc9hz5().s[13]++;
  var isHREFValid = function isHREFValid(href) {
    cov_28pkpc9hz5().f[4]++;
    var cleanHREF = (cov_28pkpc9hz5().s[14]++, href.trim());
    cov_28pkpc9hz5().s[15]++;
    return (cov_28pkpc9hz5().b[2][0]++, cleanHREF !== '') && (cov_28pkpc9hz5().b[2][1]++, !cleanHREF.startsWith('javascript')) && (cov_28pkpc9hz5().b[2][2]++, !cleanHREF.endsWith('#'));
  };
  cov_28pkpc9hz5().s[16]++;
  (0, _toConsumableArray2.default)(body.querySelectorAll('a')).filter(function (link) {
    cov_28pkpc9hz5().f[5]++;
    cov_28pkpc9hz5().s[17]++;
    return isHREFValid(link.getAttribute('href'));
  }).filter(function (link) {
    cov_28pkpc9hz5().f[6]++;
    cov_28pkpc9hz5().s[18]++;
    return !link.getAttribute('target');
  }).forEach(function (link) {
    cov_28pkpc9hz5().f[7]++;
    cov_28pkpc9hz5().s[19]++;
    return link.setAttribute('target', '_top');
  });
}
function iframeResizer(iframeToResize) {
  cov_28pkpc9hz5().f[8]++;
  function resizeIframe(iframe, callback) {
    cov_28pkpc9hz5().f[9]++;
    var doc = (cov_28pkpc9hz5().s[20]++, iframe.contentWindow.document);
    var body = (cov_28pkpc9hz5().s[21]++, doc.body);
    var height = (cov_28pkpc9hz5().s[22]++, Math.max(body.offsetHeight, body.clientHeight));
    cov_28pkpc9hz5().s[23]++;
    iframe.height = "".concat(height, "px"); // eslint-disable-line no-param-reassign
    cov_28pkpc9hz5().s[24]++;
    requestAnimationFrame(callback);
  }
  cov_28pkpc9hz5().s[25]++;
  var _syncResize = function syncResize() {
    cov_28pkpc9hz5().f[10]++;
    cov_28pkpc9hz5().s[26]++;
    return resizeIframe(iframeToResize, _syncResize);
  };
  cov_28pkpc9hz5().s[27]++;
  requestAnimationFrame(_syncResize);
  cov_28pkpc9hz5().s[28]++;
  makeLinksOpenOnTop(iframeToResize);
}